import React, { useState } from 'react';
import {
  Typography,
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
  Collapse
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Link } from 'react-router-dom';

export const seoMeta = {
  title: 'Чаршафи ранфорс 100% памук | Над 100 размера по поръчка | GoToBed',
  description:
    'Долни чаршафи ранфорс от 100% памук. Едноцветни и шарени, над 100 размера. Изработка по поръчка. Поръчайте от GoToBed.'
};

const seoLinkStyle = {
  color: '#F57819',
  textDecoration: 'underline',
  fontWeight: 600,
  '&:hover': { color: '#A34D08' }
};

export function SeoHeader() {
  const [introExpanded, setIntroExpanded] = useState(false);

  return (
    <Box sx={{ mb: 3 }}>
      <Typography
        component="h1"
        sx={{
          position: 'absolute',
          width: '1px',
          height: '1px',
          padding: 0,
          margin: '-1px',
          overflow: 'hidden',
          clip: 'rect(0, 0, 0, 0)',
          whiteSpace: 'nowrap',
          borderWidth: 0
        }}>
        Чаршафи ранфорс от 100% памук – голям избор от размери
      </Typography>
      <Typography variant="h6" component="p" fontWeight={600} sx={{ mb: 2 }}>
        Чаршафи ранфорс от 100% памук – голям избор от размери
      </Typography>
      <Box
        sx={{
          ...(!introExpanded && {
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden'
          })
        }}>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          В тази категория ще откриете долни чаршафи ранфорс от 100% памук, които се отличават със
          здравина, добра дишаемост и комфорт при ежедневна употреба. Ранфорсът е висококачествен
          памучен плат, който е много подходящ за спално бельо и осигурява приятно усещане по време
          на сън. Нашето основно предимство е голямото разнообразие от размери, което позволява
          лесно да изберете подходящ чаршаф за матрак както за стандартни, така и за по-големи или
          нестандартни легла. Предлагаме едноцветни модели и шарени десени с принт, които съчетават
          практичност и стил. Сред най-търсените размери са 150/220, 160/240, 180/220, 200/220,
          220/240, 240/260, 260/280 и 300/320.
        </Typography>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          Ако търсите и други продукти за спалнята, можете да разгледате и:
        </Typography>
        <Box sx={{ mb: 2, pl: 2 }}>
          <Typography
            variant="body1"
            component={Link}
            to="/kategorii/spalno-belio/charshafi/1/1"
            sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
            всички чаршафи
          </Typography>
          <Typography
            variant="body1"
            component={Link}
            to="/kategorii/spalno-belio/charshafi-s-lastik/1/3"
            sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
            чаршафи с ластик
          </Typography>
        </Box>
      </Box>
      <Button
        onClick={() => setIntroExpanded(!introExpanded)}
        size="small"
        sx={{
          color: '#F57819',
          textTransform: 'none',
          fontWeight: 600,
          p: 0,
          minWidth: 0,
          '&:hover': { backgroundColor: 'transparent', textDecoration: 'underline' }
        }}>
        {introExpanded ? 'Скрий' : 'Прочетете повече'}
      </Button>
    </Box>
  );
}

export default function SeoBody() {
  return <SeoBodyCharshafiRanfors />;
}

function SeoBodyCharshafiRanfors() {
  const [expanded, setExpanded] = useState(false);

  return (
    <Box sx={{ mt: 6 }}>
      {/* H2: Чаршафи ранфорс от 100% памук – удобен избор за всеки матрак */}
      <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
        Чаршафи ранфорс от 100% памук – удобен избор за всеки матрак
      </Typography>
      <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
        Чаршафите ранфорс са практично решение за комфортен и спокоен сън. Ранфорсът е 100% памучен
        плат, който се отличава със здравина, добра дишаемост и приятна на допир текстура.
        Благодарение на тези качества памучните чаршафи от ранфорс са много подходящи за ежедневно
        използване и запазват качествата си дори след многократно пране.
      </Typography>
      <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
        В нашия онлайн магазин ще откриете долни чаршафи от ранфорс, изработени от висококачествен
        100% памук. Всеки чаршаф се изработва внимателно в България и е съобразен с избраните
        размери, което позволява да намерите подходящ чаршаф за матрак както за стандартни, така и
        за нестандартни легла.
      </Typography>
      <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
        Колекцията включва едноцветни модели и шарени десени с принт, които лесно се съчетават с
        различни стилове спално бельо.
      </Typography>
      <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
        За да създадете цялостен комплект спално бельо от същата материя, можете да комбинирате
        чаршафите и с:
      </Typography>
      <Box sx={{ mb: 2, pl: 2 }}>
        <Typography
          variant="body1"
          component={Link}
          to="/produkti/spalno-belio/plikove-za-zavivka/1/4/2"
          sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
          пликове за завивки ранфорс
        </Typography>
        <Typography
          variant="body1"
          component={Link}
          to="/produkti/spalno-belio/kalufki/1/2/2"
          sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
          калъфки за възглавници ранфорс
        </Typography>
        <Typography
          variant="body1"
          component={Link}
          to="/produkti/spalno-belio/charshafi-s-lastik/1/3/2"
          sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
          чаршафи с ластик ранфорс
        </Typography>
      </Box>
      <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
        Ако предпочитате по-фина и гладка памучна материя, можете да разгледате и:
      </Typography>
      <Box sx={{ mb: 4, pl: 2 }}>
        <Typography
          variant="body1"
          component={Link}
          to="/produkti/spalno-belio/charshafi/1/1/1"
          sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
          чаршафи памучен сатен
        </Typography>
      </Box>

      <Collapse in={expanded} collapsedSize={0}>
        {/* H2: Чаршафи ранфорс в над 100 различни размера */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Чаршафи ранфорс в над 100 различни размера
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Едно от най-големите предимства на нашите чаршафи от ранфорс е богатото разнообразие от
          размери. Предлагаме над 100 различни размера, което позволява лесно да изберете подходящ
          чаршаф по размер за вашето легло.
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Най-често клиентите търсят чаршафи ранфорс по размер като 220/240, 240/260 или 260/280,
          които позволяват удобно покриване и подпъхване под матрака.
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Чаршафите за матраци могат да бъдат изработени с размери от 110/210 см до 360/360 см, като
          размерите се увеличават през 10 см. Това ги прави подходящи както за стандартни легла,
          така и за по-големи или нестандартни матраци.
        </Typography>

        <Typography variant="h6" component="h3" fontWeight={600} sx={{ mb: 1 }}>
          Най-популярни размери чаршафи ранфорс
        </Typography>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          Сред най-популярните размери са:
        </Typography>
        <Box sx={{ mb: 2, pl: 2 }}>
          {[
            'чаршаф 150/220 (150х220) см',
            'чаршаф 160/240 (160х240) см',
            'чаршаф 180/220 (180х220) см',
            'чаршаф 200/220 (200х220) см',
            'чаршаф 220/240 (220х240) см',
            'чаршаф 240/260 (240х260) см',
            'чаршаф 260/280 (260х280) см',
            'чаршаф 300/320 (300х320) см'
          ].map((item) => (
            <Typography key={item} variant="body1" sx={{ color: 'text.secondary' }}>
              {item}
            </Typography>
          ))}
        </Box>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          Благодарение на този широк избор можете лесно да намерите подходящ памучен чаршаф за
          матрак, дори когато размерът е по-нестандартен.
        </Typography>

        {/* H2: Какво представлява платът ранфорс? */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Какво представлява платът ранфорс?
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Ранфорсът е плътна памучна тъкан, изработена от 100% естествени памучни влакна. Този плат
          е много популярен за спално бельо, защото съчетава комфорт, здравина и дълготрайност.
        </Typography>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          Основни предимства на ранфорса:
        </Typography>
        <Box component="ul" sx={{ pl: 4, color: 'text.secondary', mt: 0 }}>
          <li>&#10004; 100% естествен памук</li>
          <li>&#10004; добра дишаемост и комфорт по време на сън</li>
          <li>&#10004; здрав и издръжлив плат</li>
          <li>&#10004; мека и приятна на допир материя</li>
          <li>&#10004; подходящ за използване през всички сезони</li>
        </Box>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          Всички наши чаршафи ранфорс се изработват от платове със сертификат OEKO-TEX Standard 100,
          който гарантира, че текстилът не съдържа вредни вещества.
        </Typography>

        {/* H2: Предимства на нашите чаршафи от ранфорс */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Предимства на нашите чаршафи от ранфорс
        </Typography>
        <Box component="ul" sx={{ pl: 4, color: 'text.secondary', mt: 0 }}>
          <li>&#10004; изработени от 100% памук ранфорс</li>
          <li>&#10004; над 100 различни размера</li>
          <li>&#10004; размери от 110/210 до 360/360 см</li>
          <li>&#10004; подходящи за стандартни и нестандартни матраци</li>
          <li>&#10004; дишащ и издръжлив памучен плат</li>
          <li>&#10004; шарени и едноцветни модели</li>
          <li>&#10004; платове със сертификат OEKO-TEX Standard 100</li>
          <li>&#10004; произведени в България</li>
        </Box>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          Нашите долни чаршафи от ранфорс са практичен избор за хора, които търсят качествено
          памучно спално бельо с дълготрайност и комфорт.
        </Typography>

        {/* H2: Още продукти от ранфорс за вашата спалня */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Още продукти от ранфорс за вашата спалня
        </Typography>
        <Box sx={{ mb: 4, pl: 2 }}>
          <Typography
            variant="body1"
            component={Link}
            to="/produkti/spalno-belio/plikove-za-zavivka/1/4/2"
            sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
            пликове за завивки ранфорс
          </Typography>
          <Typography
            variant="body1"
            component={Link}
            to="/produkti/spalno-belio/kalufki/1/2/2"
            sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
            калъфки за възглавници ранфорс
          </Typography>
          <Typography
            variant="body1"
            component={Link}
            to="/produkti/spalno-belio/charshafi-s-lastik/1/3/2"
            sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
            чаршафи с ластик ранфорс
          </Typography>
        </Box>

        {/* H2: Срок за изработка */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Срок за изработка
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Всички чаршафи се изработват индивидуално след направена поръчка, според избрания размер и
          материя.
        </Typography>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          Срокът за изработка е между 3 и 10 работни дни, като в повечето случаи поръчките са готови
          в рамките на 4–7 работни дни.
        </Typography>

        {/* H2: Най-търсени размери чаршафи ранфорс */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Най-търсени размери чаршафи ранфорс
        </Typography>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          В нашия онлайн магазин можете да откриете чаршафи ранфорс в много различни размери. Сред
          най-търсените размери от клиентите са:
        </Typography>
        <Box sx={{ mb: 2, pl: 2 }}>
          {[
            'чаршаф 160/240 (160х240) см',
            'чаршаф 180/220 (180х240) см',
            'чаршаф 200/220 (200х220) см',
            'чаршаф 220/240 (220х240) см',
            'чаршаф 240/260 (240х260) см',
            'чаршаф 260/280 (260х280) см',
            'чаршаф 300/320 (300х320) см'
          ].map((item) => (
            <Typography key={item} variant="body1" sx={{ color: 'text.secondary' }}>
              {item}
            </Typography>
          ))}
        </Box>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          Тези размери са подходящи за различни видове матраци и позволяват удобно покриване и
          подпъхване под матрака.
        </Typography>
      </Collapse>
      <Button
        onClick={() => setExpanded(!expanded)}
        sx={{
          color: '#F57819',
          textTransform: 'none',
          fontWeight: 600,
          mb: 3,
          '&:hover': { backgroundColor: 'rgba(212, 175, 55, 0.08)' }
        }}>
        {expanded ? 'Скрий' : 'Прочетете повече'}
      </Button>

      {/* H2: ЧЗВ */}
      <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 3 }}>
        Често задавани въпроси за чаршафи ранфорс
      </Typography>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Какво представлява платът ранфорс?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Ранфорсът е 100% памучен плат с добра плътност, здравина и отлична дишаемост. Той е
            много подходящ за спално бельо и чаршафи, защото осигурява комфорт по време на сън и
            запазва качествата си дори след многократно пране.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Свива ли се чаршафът от ранфорс след пране?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
            Както всички изделия от 100% памук, и чаршафите от ранфорс могат да имат естествена
            свиваемост около 4–5% след първите пранета. Това е нормално свойство на памучните
            материи.
          </Typography>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Ако желаете чаршафът да има по-голяма покривност или да се подпъхва под матрака, е добре
            да изберете малко по-голям размер.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Как да избера правилния размер чаршаф?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
            За да изберете подходящ чаршаф за матрак, измерете ширината и дължината на матрака. След
            това изберете чаршаф със съответстващ размер.
          </Typography>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Ако предпочитате чаршафът да се подпъхва под матрака, е добре да изберете малко по-голям
            размер, за да има достатъчно плат за подпъхване.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Подходящи ли са чаршафите от ранфорс за големи матраци?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Да. Предлагаме чаршафи ранфорс в над 100 различни размера, включително и за много големи
            матраци до 360/360 см. Това ги прави подходящи както за стандартни, така и за
            нестандартни легла.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Къде се изработват чаршафите?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Всички чаршафи от ранфорс се изработват в България, специално за всяка поръчка и според
            избрания размер.
          </Typography>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
}
